var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.domId,staticClass:"scroll-box",attrs:{"id":_vm.domId}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }